module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/8791dbc4de0543d6bf2f63b83d6dcb44.png";